import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

const UnderConstruction = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center bg-light p-16">
      
      {/* Logo */}
      <div className="mb-40 text-center">
        <img 
          src="assets/images/SoksanLogo.png" 
          alt="Logo" 
          style={{ maxWidth: '150px' }}
          className="img-fluid"
        />
      </div>

      {/* Content */}
      <div className="text-center max-w-500-px w-100">
        
        {/* Icon */}
        <div className="mb-24">
          <Icon 
            icon="solar:construction-bold" 
            fontSize={80} 
            style={{ color: "#FAA61A" }} 
          />
        </div>

        {/* Heading */}
        <h3 className="mb-26 fw-bold text-capitalize">
          Under Construction
        </h3>

        {/* Description */}
        <p className="text-secondary mb-32 fs-5">
          We're currently working on this page to bring you an improved experience. 
          Thank you for your patience!
        </p>

        {/* Back Button */}
        <Link 
          to="/" 
          className="btn btn-lg px-24 py-12 radius-12"
          style={{ 
            backgroundColor: "#FAA61A", 
            borderColor: "#FAA61A", 
            color: "#fff" 
          }}
        >
          Go to Homepage
        </Link>

        {/* Contact Info */}
        <div className="mt-40 pt-24 border-top">
          <p className="text-secondary mb-8">Questions? Contact us:</p>
          <div className="d-flex justify-content-center gap-3">
            <a href="mailto:support@domain.com" className="text-decoration-none">
              <span className="text-primary">support@soksan.com</span>
            </a>
          </div>
        </div>

      </div>
    </div>
  );
};

export default UnderConstruction;